import React, { createContext, PropsWithChildren, useCallback, useContext, useState } from "react";

interface ForgotPasswordDialogState {
    open: boolean;
}

interface ForgotPasswordDialogActions {
    openForgotPassword: () => void;
    closeForgotPassword: () => void;
}

interface ForgotPasswordDialogContextValue {
    state: ForgotPasswordDialogState;
    actions: ForgotPasswordDialogActions;
}

const ForgotPasswordDialogContext = createContext<ForgotPasswordDialogContextValue>({
    state: { open: false },
    actions: {
        openForgotPassword: () => {},
        closeForgotPassword: () => {},
    },
});

const Provider: React.FC<PropsWithChildren> = ({ children }) => {
    const [open, setOpen] = useState(false);

    const openForgotPassword = useCallback(() => {
        setOpen(true);
    }, []);

    const closeForgotPassword = useCallback(() => {
        setOpen(false);
    }, []);

    return (
        <ForgotPasswordDialogContext.Provider value={{ state: { open }, actions: { openForgotPassword, closeForgotPassword } }}>
            {children}
        </ForgotPasswordDialogContext.Provider>
    );
};

const useForgotPasswordDialog = () => useContext(ForgotPasswordDialogContext);

export { ForgotPasswordDialogContext as Context, Provider, useForgotPasswordDialog };
